module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Chapter")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2title"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Two")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DRENALINE MADE")]), _vm._v(" Nancy’s heart pound as she peered toward the bathroom. Whoever was in there could be dangerous.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come on, Nan!” George whispered, inching out the open door. Bess was already in the hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Nancy backed away, she got a glimpse of the intruder. It was a girl—a petite brunette with short-cropped straight hair. She was wearing a crisp white uniform with a blue apron. Nancy felt a surge of relief. The girl wasn’t a thief—she was a maid!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Taking a step forward, Nancy opened the bathroom door wide. At the same instant the girl shut off the water and turned around. She blanched when she came face-to-face with Nancy. ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("“Oh,” she gasped, clutching a wet cloth in her hands. “I didn’t hear you come in.”")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy crossed her arms over her chest and stared at the girl. “We weren’t expecting maid service, since we just checked in this afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just checked in—yes. Well, welcome to Mykonos.” The girl nodded, then walked past Nancy and nervously knelt beside the puddle of spilled makeup. “I’m very sorry about this mess. I bumped into the case, and it fell open.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy watched the maid as she started dabbing at the puddle. From the young woman’s red face, Nancy could tell that she was embarrassed. And from the mess in the room, it was obvious to Nancy that the girl hadn’t knocked over Bess’s luggage. She had been going through it. But why?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George poked her head into the room, surveyed the situation, then joined Nancy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The maid seemed afraid to look up. She rubbed the wooden floor until not a trace of makeup remained, then said, “I just came to your room to bring you extra towels and some fresh fruit. Zoe wanted her American friends to feel welcome.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy glanced over at the low wooden table. A stack of white towels and a wide bowl filled with oranges, bananas, and grapes sat on the tabletop. “That was nice of Zoe,” she said. Then she looked pointedly at the mess on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The maid began to fumble with the snarled necklaces on the floor.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Bess exchanged a look with Nancy and George, ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("then bent down to help the maid return the jewelry to the overnight case. “Well, it looks like everything is here and okay. Don’t worry about it,” she told the girl. “My name is Bess Marvin. And this is Nancy Drew and George Fayne.”")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Niki Christofouros,” the maid introduced herself, scrambling to her feet and nodding at the girls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy looked carefully at the girl. She had large black eyes, lined with dark makeup, which gave her a mysterious look. With her high cheekbones and stylish bob, Nancy thought that Niki looked as if she had stepped off the cover of a fashion magazine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks for the fruit,” Nancy said, deciding not to press the issue. “Tell Zoe that we feel very much at home here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I’ll tell her,” Niki promised, edging away. Then she disappeared out the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George closed the door, then glanced around the room. “What’s her problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("was")]), _vm._v(" acting strange,” Nancy agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bess was sifting through her open suitcase. “There doesn’t seem to be anything missing, but why was she going through my stuff?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s exactly what I was wondering,” Nancy said as she sank down onto one of the room’s three beds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And why just your stuff, Bess?” George wanted to know. “She didn’t touch ours.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Probably because she has excellent taste,” Bess said with a mischievous look.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Nancy groaned and tossed a pillow at Bess, who batted it away with her hands. “This is serious. Aren’t you the least bit suspicious?” Nancy asked.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lighten up, Nan,” Bess said. “This is our vacation!” She slipped into the bathroom, calling out, “I’ve got the first shower!”")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("• • •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("An hour later, dressed in shorts, T-shirts, and sneakers, Nancy, Bess, and George were ready to hike into Chora. Armed with their guidebook and instructions from Zoe, the girls set off on the mile-long walk to town.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you guys notice the tension between Zoe and that guy Theo before?” Nancy asked as they trudged uphill on a paved road that crossed the rocky hillside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bess nodded. “I got the feeling that Zoe resents him. Maybe they didn’t break up on great terms.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When we were in Olympia, Zoe did mention something about a guy who broke things off,” George said. “Theo seems like a nice guy, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bess wiggled her eyebrows suggestively at her cousin. “That’s a rave from you,” she said. “Do I detect the start of a new romance?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("“No way.” George raised her hands defensively. “Kevin’s the only guy on my mind these days.” George really liked her boyfriend, sports commentator Kevin Davis. Even if there had been a lot of strain between them because ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Kevin’s job required him to travel frequently, Nancy knew that George was serious about their relationship.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I think Theo’s adorable,” Bess said. She giggled and added, “So’s Dimitri.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Face it, Bess,” George said. “You’re in love with love.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They had just rounded a crest in the road, and Nancy could see Mykonos’s distinctive white windmills in the distance. The five round towers seemed to dominate the harbor from their perch on a hill. Below the windmills, dazzling snow white buildings hugged the shoreline.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the girls continued, the countryside gave way to meandering alleyways lined with cubeshaped houses. Cars were restricted from the cobblestone streets, but the area was busy with tourists, local merchants, and people leading donkeys with food and supplies strapped to their backs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Zoe told me that the buildings are whitewashed to protect them from the sun,” George said as they passed one house.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She also warned me about the zigzagging streets,” Nancy added. They were just passing a narrow, twisting lane. “They were originally designed to foil pirate raiders, so it’s easy to get lost if you don’t watch where you’re going.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry,” Bess said. “The maze of streets may have confused pirates, but a determined shopper will always find her way.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Following Zoe’s directions, the girls turned ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("down Matoyianni, the main street of town. Shops, cafés, and bakeries stretched out in front of them. The Greek alphabet, so different from English, made it impossible for the girls to read the signs and letters painted on shop windows. But Nancy noticed that the vendors managed to get their messages across by displaying their merchandise.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, wait a minute,” Bess said, stopping in front of a stationery store. “That’s the most adorable statue I’ve ever seen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy paused to see what had caught Bess’s eye. In the window of the small shop sat a tiny white replica of one of Mykonos’s windmills. It was surrounded by miniature white houses, fish, boats, and even a pelican. “It is an amazing piece of craftsmanship,” she agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll bet the sails even move,” Bess said. “I wish I’d cashed some traveler’s checks, but I left them in the safe at the hotel. I don’t have much Greek currency—just a few drachmas.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank goodness,” George said with an exaggerated sigh. “Otherwise, we’d have to hire a donkey to carry your purchases back to the inn.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy and George followed as Bess went into the shop. The small room was jammed with floor-to-ceiling shelves stocked with international newspapers, magazines, postcards, and writing paper. An elderly man with white hair and a wooden pipe clenched between his teeth sat next to a counter against one wall.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("When Bess pointed out the windmill to the shopkeeper, he handed it to her so she could have ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("a closer look. “I make,” he said, pointing to his chest")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You did?” Bess said. “Oh, I love it. This is the perfect birthday gift for my mother.” Her blue eyes sparkled—until she saw the price. “I guess I’ll have to come back after I change more money,” she told the elderly shopkeeper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After thanking him for his help, the girls left the shop. “I wish he hadn’t put it back on display,” Bess said, pausing outside the shop as the shopkeeper reached down and replaced the statue in the window. “What if someone else buys it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Relax, Bess,” Nancy assured her. “Why don’t you cash a traveler’s check at the hotel? If there’s time, we can make a quick trip back here before dinner—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The gorgeous American girls!” a familiar voice interrupted Nancy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy turned and immediately recognized Dimitri, the photographer from the beach. His dark curls glistened in the sunlight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s us!” Bess said, grinning at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Would you like a photo here in Chora?” Dimitri asked, raising his camera.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, thanks,” Nancy replied. “We were just doing some shopping.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, in the shop of my good friend Spiros,” Dimitri said, nodding at the stationery store. “That is my studio, just above.” He pointed to a narrow white stone staircase along the side of the building that led to a room just above the shop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bess brightened. “You have your own studio?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“Of course,” Dimitri boasted, never taking his eyes off Bess. “I need a darkroom for my business. I have all the latest equipment.”")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d love to see the studio,” Bess told him. “Could you give us a little tour?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now?” Dimitri hesitated. “I’ve been very busy today. It’s a mess.” A group of Japanese tourists caught Dimitri’s eye, and he excused himself to snap a few photographs. “I will see you later, I hope,” he told Bess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy was surprised at Dimitri’s abrupt switch. One minute the guy was melting over Bess, the next minute he seemed to freeze. Bess had noticed his behavior, too. “I can’t decide if he was trying to get a date or give me the brush-off,” she said. Shrugging, she added, “Well, I’m not going to let it ruin my day. Come on, guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main street ended at a busy waterfront strip. The crescent-shaped harbor was ringed by hotels, cafés, and tavernas. Small fishing boats skimmed along the water. It all looked tempting. Nancy wasn’t quite sure which way to turn first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bess persuaded Nancy and George to go into a pastry shop. “After all,” she reminded them as they walked inside and peered into a glass case full of cakes and honey pastries, “we won’t be eating dinner for a few more hours.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After buying honeyed pastries called "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("baklava,")]), _vm._v(" the girls turned back up the main street, retracing their steps through the maze of narrow lanes toward the hotel.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“We might as well go straight to the office,” ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Bess said when they reached the hotel half an hour later. “I can get my traveler’s checks and passport for ID.” For security reasons, the hotel requested that all valuables, including passports, be left in the office safe.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The three girls entered the arched double doors of the main building and went to the lobby desk, which was a crescent-shaped cutaway in one of the stucco walls. Zoe was behind the tiled counter, bent over the registration book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Bess told her about the miniature she had found in Chora, Zoe smiled and closed the registration book. “You should probably take your passports with you when you leave the hotel grounds,” Zoe told them. “But I’ll be happy to cash your traveler’s checks. Let me get your envelope from the safe.” She disappeared through a doorway behind the front desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zoe returned a few minutes later, a grim frown on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s the matter?” Nancy asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s the safe,” Zoe told her. “Someone has broken into it!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60927b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 60
// module chunks = 0